// The one markdown pipeline a tutor message is rendered through: the table
// repair followed by the configured markdown-it instance.
//
// It lives in its own module, rather than inside TutorMessage.vue, so that the
// phrase-replay fixtures render through exactly the pipeline the bubble uses.
// The phrase markers are placed before this pipeline runs and located after
// it, so a fixture rendered any other way would prove nothing about the bubble.

import MarkdownIt from "markdown-it";
import { normalizeMarkdownTables } from "@/scripts/markdownTables";

// Config never varies per message, so the parser is built once and shared.
export const tutorMarkdown = new MarkdownIt({
  html: false, // never render LLM-supplied HTML (prompt-injection XSS)
  linkify: true,
  typographer: true,
});

// Tables need a scrollable card wrapper (wide vocab tables must scroll inside
// the message, never the page) and CSS alone can't add a wrapper element.
tutorMarkdown.renderer.rules.table_open = () => '<div class="md-table"><table>';
tutorMarkdown.renderer.rules.table_close = () => "</table></div>";

/**
 * The HTML a tutor message's text renders to.
 *
 * Table blocks whose header and delimiter rows disagree on cell count are
 * repaired before markdown-it sees them. Left alone, markdown-it refuses the
 * whole block and the learner gets a paragraph of literal pipes; doing it at
 * render time rather than on the server is what also repairs the messages
 * already stored in RTDB. Well-formed markdown comes back untouched.
 * @param {string} text
 * @returns {string}
 */
export function renderTutorMarkdown(text) {
  return tutorMarkdown.render(normalizeMarkdownTables(text));
}
